module.exports = __webpack_public_path__ + "static/images/1f2df0acd1549aff52ae0ccb02db870e.svg";